import { loggingContexts } from "./data/logging-contexts.js";
import { log } from "./log.js";
import { pruneLogEntries } from "./prune-log-entries.js";
import { pruneLogFiles } from "./prune-log-files.js";

const pruneLogsLog = log(loggingContexts.pruneLogs);

export const pruneLogs = async () => {
  pruneLogsLog.info("about to prune logs");

  const [files, entries] = await Promise.all([
    pruneLogFiles(),
    pruneLogEntries(),
  ]);

  return { files, entries };
};
